import React from 'react';
import { FaHandshake, FaTrophy, FaLayerGroup } from 'react-icons/fa';
import { MdOutlineSupportAgent, MdOutlinePrecisionManufacturing, MdOutlineDevices } from 'react-icons/md';

const WhyUbiSoft = () => {
  const cards = [
    {
      icon: <FaHandshake className="text-5xl text-blue-600" />,
      title: 'Relative Partner',
      description:
        'We work as your extended team, understanding your business goals and aligning with your vision for long-term success.',
      gradient: 'from-blue-50 to-indigo-50',
      borderHover: 'hover:border-blue-300',
    },
    {
      icon: <FaTrophy className="text-5xl text-amber-500" />,
      title: 'High Quality Solutions',
      description:
        'Delivering robust, scalable, and innovative solutions that meet the highest industry standards.',
      gradient: 'from-amber-50 to-orange-50',
      borderHover: 'hover:border-amber-300',
    },
    {
      icon: <FaLayerGroup className="text-5xl text-purple-500" />,
      title: 'Full Spectrum Services',
      description:
        'From strategy and design to development and support, we cover every aspect of your digital journey.',
      gradient: 'from-purple-50 to-pink-50',
      borderHover: 'hover:border-purple-300',
    },
  ];

  const bottomFeatures = [
    {
      icon: <MdOutlineSupportAgent className="text-3xl text-blue-500" />,
      title: 'Relative Partner',
      description: 'We become your strategic ally, not just a vendor.',
    },
    {
      icon: <MdOutlinePrecisionManufacturing className="text-3xl text-amber-500" />,
      title: 'High Quality Solutions',
      description: 'Built with precision, tested for excellence.',
    },
    {
      icon: <MdOutlineDevices className="text-3xl text-purple-500" />,
      title: 'Full Spectrum Services',
      description: 'End-to-end expertise under one roof.',
    },
  ];

  return (
    <section className="relative bg-gradient-to-br from-gray-50 via-white to-gray-100 py-20 md:py-28 overflow-hidden">
      {/* Abstract background decoration */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 -left-40 w-80 h-80 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
        <div className="absolute top-0 -right-40 w-80 h-80 bg-amber-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-40 left-20 w-80 h-80 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold">
            <span className="text-red-600">Why</span>{' '}
            <span className="text-gray-900">UB Creation</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            We combine innovation, expertise, and partnership to drive your success.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className={`group relative bg-gradient-to-br ${card.gradient} rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-transparent ${card.borderHover} backdrop-blur-sm`}
            >
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/30 pointer-events-none"></div>
              <div className="relative">
                <div className="flex justify-center mb-6">{card.icon}</div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">{card.title}</h3>
                <p className="text-gray-600 leading-relaxed">{card.description}</p>
                <div className="w-12 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 mx-auto mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            </div>
          ))}
        </div>

       
      </div>

      {/* Custom animations */}
      <style jsx>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </section>
  );
};

export default WhyUbiSoft;